import {
  Button,
  ClickAwayListener,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { useState } from "react";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    sx={{ fontSize: 40 }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.common.black,
    color: theme.palette.warning.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(14),
  },
}));

type UserParcelCenterTooltipProps = {
  parcelCenters: string[];
};

const UserParcelCenterTooltip = ({
  parcelCenters,
}: UserParcelCenterTooltipProps) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("more...");

  const handleTooltipClose = () => {
    setOpen(false);
    setText("more...");
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
    setText(open ? "more..." : "less...");
  };
  return (
    <>
      {parcelCenters.length > 1 ? (
        <div>
          {parcelCenters[0]}
          <div>{parcelCenters[1]}</div>
          <div>{parcelCenters[2]}</div>
        </div>
      ) : (
        <div>
          {parcelCenters.includes("Out of Area") ? "All" : parcelCenters}
        </div>
      )}
      <div></div>

      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <BootstrapTooltip
            open={open}
            PopperProps={{
              disablePortal: false,
            }}
            title={
              parcelCenters.length > 3 ? (
                <ul style={{ padding: "inherit", listStyleType: "none" }}>
                  {parcelCenters.map((parcelCenter) => (
                    <li key={parcelCenter}>{parcelCenter}</li>
                  ))}
                </ul>
              ) : (
                <div>
                  {parcelCenters.includes("Out of Area")
                    ? "All"
                    : parcelCenters}
                </div>
              )
            }
          >
            {parcelCenters.length > 3 ? (
              <Button
                sx={{
                  textTransform: "lowercase",
                  padding: "8px",
                  lineHeight: "0px",
                  color: "blue",
                }}
                disableElevation={true}
                disableRipple={true}
                size="large"
                onMouseOver={() => {
                  handleTooltipOpen();
                }}
                onMouseLeave={() => handleTooltipClose()}
              >
                {text}
              </Button>
            ) : (
              <div></div>
            )}
          </BootstrapTooltip>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default UserParcelCenterTooltip;
